import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = {
  key: 1,
  class: "body"
}
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["notification", _ctx.type])
  }, [
    (_ctx.title.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.iconName.length)
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 0,
                name: _ctx.iconName,
                fill: _ctx.iconFill,
                title: _ctx.iconName
              }, null, 8, ["name", "fill", "title"]))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, _toDisplayString(_ctx.title), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasSlotData || _ctx.message.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.iconName.length && !_ctx.title.length)
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 0,
                name: _ctx.iconName,
                fill: _ctx.iconFill,
                title: _ctx.iconName
              }, null, 8, ["name", "fill", "title"]))
            : _createCommentVNode("", true),
          (_ctx.message.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.message), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}